import homeFill from '@iconify/icons-eva/home-fill';
import { Icon } from '@iconify/react';
import { Avatar, Box, Button, Divider, IconButton, MenuItem, Typography, Tooltip } from '@material-ui/core';
// material
import { alpha } from '@material-ui/core/styles';
import { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { getUserInfo } from 'src/services/tokens';
// components
import MenuPopover from '../../components/MenuPopover';
//
import account from '../../_mocks_/account';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Inicio',
    icon: homeFill,
    linkTo: '/'
  }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const user = getUserInfo();
  const navigate = useNavigate();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const closeSesion = () => {
    localStorage.clear();

    navigate('/login', { replace: true });
  }

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar src={account.photoURL} alt="photoURL" />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Tooltip title={!!user ? user['cognito:username'] : ''}>
            <Typography variant="subtitle1" noWrap sx={{
              textOverflow: 'ellipsis',
              whiteSpace: "nowrap",
              overflow: 'hidden',
              maxWidth: "156px"
            }}>
              {!!user ? (user['cognito:groups'][0]).toUpperCase() : ''}
            </Typography>
          </Tooltip>
          <Tooltip title={!!user ? user['cognito:username'] : ''}>
            <Typography variant="body2" sx={{ 
              color: 'text.secondary',
              fontSize: '12px',
              textOverflow: 'ellipsis',
              whiteSpace: "nowrap",
              overflow: 'hidden',
              maxWidth: "156px" }} noWrap >
              {!!user ? user['cognito:username'] : ''}
            </Typography>
          </Tooltip>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined" onClick={closeSesion}>
            Cerrar sesión
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
